export default __webpack_public_path__ + "static/media/Medicine.72bb6358.svg";